<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>직구정보</h3>
				<h4>간단한 직구 스킬을 알려드릴게요.</h4>
			</div>
			<div class="type-card">
				<div class="card-head">1. 지역변경</div>
				<div class="card-body">
					<p class="mb40">
						한국에서 타오바오로 로그인 후 中国大陸으로 지역 변경을 해주세요.<br>
						변경 전보다 훨씬 다양한 상품이 노출 검색됩니다.<br>
						구매선택의 폭이 다양해지는 경험을 해보세요.
					</p>
					<div class="img-box">
						<img loading="lazy" v-if="isMobile" src="../../assets/list/document_process_img1_2x.png" alt="" class="img-responsive">
						<img loading="lazy" v-else src="../../assets/list/document_process_img1.png" alt="" class="img-responsive ">
					</div>
				</div>
			</div>
			
		</div>
		<div class="content-zsy">
			<div class="type-card">
				<div class="card-head">2. 이미지 검색</div>
				<div class="card-body">
					<p class="mb40">
						쇼핑 중에 맘에 드는 상품을 발견하시면 <br class="visible-xs">해당상품 이미지를 캡쳐하세요.<br>
						카메라 아이콘을 클릭 후 <br class="visible-xs">캡쳐하신 상품이미지로 검색해보세요.
					</p>
					<el-row style="padding:10px 0;">
						<el-col :xs="24" :sm="12">
							<div class="img-box">
								<img loading="lazy" v-if="isMobile" src="../../assets/list/document_process_img2_2x.png" alt="" class="img-responsive">
								<img loading="lazy" v-else src="../../assets/list/document_process_img2.png" alt="" class="img-responsive ">
							</div>
						</el-col>
						<el-col :xs="24" :sm="12">
							<div class="img-box">
								<img loading="lazy" v-if="isMobile" src="../../assets/list/document_process_img3_2x.png" alt="" class="img-responsive">
								<img loading="lazy" v-else src="../../assets/list/document_process_img3.png" alt="" class="img-responsive ">
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div class="content-zsy">
			<div class="type-card">
				<div class="card-head">3. 흥정하기</div>
				<div class="card-body">
					<p class="mb40">
						상품 상세페이지 표시 부분을 누르시거나
					</p>
					<div class="img-box">
						<img loading="lazy" v-if="isMobile" src="../../assets/list/document_process_img4_2x.png" alt="" class="img-responsive">
						<img loading="lazy" v-else src="../../assets/list/document_process_img4.png" alt="" class="img-responsive ">
					</div>
					<p class="mb40" style="padding-top: 10px;">
						장바구니에 상품을 담아두셨다면 장바구니에서 물방울 표시를 클릭하세요.
					</p>
					<div class="img-box">
						<img loading="lazy" v-if="isMobile" src="../../assets/list/document_process_img5_2x.png" alt="" class="img-responsive">
						<img loading="lazy" v-else src="../../assets/list/document_process_img5.png" alt="" class="img-responsive ">
					</div>
					<p class="mb40" style="padding-top: 10px;">
						판매자와 채팅 프로그램(알리왕왕)으로
					</p>
					<div class="img-box">
						<img loading="lazy" v-if="isMobile" src="../../assets/list/document_process_img6_2x.png" alt="" class="img-responsive">
						<img loading="lazy" v-else src="../../assets/list/document_process_img6.png" alt="" class="img-responsive ">
					</div>
					<p class="mb40" style="padding-top: 10px;">
						파파고 번역을 이용해서 흥정을 해보세요.<br>
						판매자에게 무리한 요구를 하지 마시고, 가볍고 소소하게 흥정을 해보세요!
					</p>
					
				</div>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	export default {
		name: 'documentprocess',
		components: {
			PersonalBanner
		},
		data() {
			return{
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			},
		},
		
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: #111;
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
		color: var(--frontground-color);
	    margin: 0;
	}
	.type-card{
		border: 1px solid var(--border-color);
		box-shadow: 8px 12px 12px rgba(0, 0, 0, 0.06);
		border-radius: 26px;
		overflow: hidden;
		margin:5px 50px 20px 50px;
	}
	.card-head{
		padding: 15px 0;
		font-weight: 700;
		font-size: 18px;
		line-height: 23px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		gap: 0 10px;
		background: var(--secondary-color);
	}
	.card-body{
		padding: 30px;
		text-align: center;
	}
	.img-box{
		display: flex;
		justify-content: center;
	}
	.mb40{
		padding-bottom: 10px;
	}
	
	.img-responsive{
		display: block;
		max-width: 100%;
		height: auto;
	}
	.visible-xs {
	    display: none !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}	
		.type-card{
			margin:5px 0 20px 0;
		}
		.mb40{
			font-size: 14px;
		}
		.visible-xs {
		    display:block !important;
		}
		
	}
	
</style>